import { segmentsStore } from '@/stores/segmentsStore'
import { pagingStore } from '@/stores/pagingStore'
import { documentStore } from '@/stores/documentStore';

import { SegmentEditorItem } from '@/models/SegmentEditorItem'
import { SegmentEditorItemType } from '../SegmentEditorItemType'

import { segmentsApi } from '@/api/segmentsApi'

export class SplitService {
    segmentsStore: any
    pagingStore: any
    documentStore: any

    segmentToSplitId: number = 0;

    constructor() {
        this.segmentsStore = segmentsStore();
        this.pagingStore = pagingStore();
        this.documentStore = documentStore();
    }

    initSplit(segmentId: number) {
        this.segmentToSplitId = segmentId;

        this.toggleSegmentVisibility();

        this.segmentsStore.setSplitState();
    }

    private toggleSegmentVisibility() {
        const segmentIndex = this.segmentsStore.getSegmentPosition(this.segmentToSplitId);
        const segment = this.segmentsStore.segmentsArray[segmentIndex];

        segment.segmentIsVisibleOnList = !segment.segmentIsVisibleOnList;
    }


    async getSegmentsWereMerged() {
        return segmentsApi.getMergedSegments(this.segmentToSplitId);
    }

    async splitMrgedSegments() {
        await this.splitSegmnetsrequest();
        this.segmentsStore.setTranslateState();
        this.documentStore.reloadDocument();
    }

    async splitSegmnetsrequest() {
        //TODO: moce to model
        const splitRequest = {
            documentId: 0,
            segmentIds: [this.segmentToSplitId],
            pageSize: this.pagingStore.pageSize,
        }

        return segmentsApi.splitMergedSegments(splitRequest);
    }

    cancelSplit() {
        this.toggleSegmentVisibility()

        this.segmentsStore.setTranslateState();
        this.removeSplitSegment();
    }

    private removeSplitSegment() {
        const segmentIndex = this.segmentsStore.segmentsArray.findIndex((s: SegmentEditorItem) => s.segmentType == SegmentEditorItemType.SplitSegment);
        this.segmentsStore.removeSegmentFromSegmentsArray(segmentIndex);
    }
}
